import { actionType } from "../actions/vedtakskoderAction";
import { CreateNewReducer } from "../utils/reducerUtils";

const INITIAL_STATE = [];
const vedtakskoderReducer = (state = INITIAL_STATE, action) =>
  CreateNewReducer(state, action, actionType);

export default vedtakskoderReducer;
